import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import portfolio from "@/data/portfolio";

// Mobile-only · subtle · premium · no promotional animation.
// Sits opposite ScrollToTop (left) — bottom-right.
export default function WhatsAppButton() {
  const [show, setShow] = useState(false);
  const url = portfolio.contact?.whatsappUrl;

  useEffect(() => {
    // Fade in once after a short delay so it never feels like a popup.
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  if (!url) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.a
          href={url}
          target="_blank"
          rel="noreferrer"
          aria-label="Message Pablo on WhatsApp"
          data-testid="mobile-whatsapp-button"
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="md:hidden fixed bottom-6 right-6 z-40 inline-flex items-center justify-center w-11 h-11 rounded-full bg-black text-white shadow-lg shadow-black/15 hover:bg-[#1a1a1a] transition-colors"
        >
          <MessageCircle className="w-4 h-4" />
        </motion.a>
      )}
    </AnimatePresence>
  );
}
